module.exports = __webpack_public_path__ + "static/media/25181860_1545557772160525_488247322_n.ad5c8428.jpg";